/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_Locality_HintInputs */

const cs_requirements_locality_hint = /** @type {(inputs: Requirements_Locality_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volitelná měkká shoda podle města. Geografický filtr je oblast výše.`)
};

const en_requirements_locality_hint = /** @type {(inputs: Requirements_Locality_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional soft match by city name. The search area above is the geographic filter.`)
};

/**
* | output |
* | --- |
* | "Optional soft match by city name. The search area above is the geographic filter." |
*
* @param {Requirements_Locality_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_locality_hint = /** @type {((inputs?: Requirements_Locality_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Locality_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_locality_hint(inputs)
	return cs_requirements_locality_hint(inputs)
});